import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=140c7ff2&scoped=true"
import script from "./DataGrid.vue?vue&type=script&lang=js"
export * from "./DataGrid.vue?vue&type=script&lang=js"
import style0 from "./DataGrid.vue?vue&type=style&index=0&id=140c7ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140c7ff2",
  null
  
)

export default component.exports